import { Component, OnInit, OnDestroy } from '@angular/core';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { ActivatedRoute, Params } from '@angular/router';
import { FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Testimonial } from 'src/app/shared/models/testimonial.model';
import { TestimonialService } from 'src/app/shared/services/testimonial.service';
import { TestimonialValues } from 'src/app/shared/resources/testimonial-values.resource';
import { MailService } from 'src/app/shared/services/mail.service';

@Component({
  selector: 'app-practitioner-testimonial',
  templateUrl: './practitioner-testimonial.component.html',
  styleUrls: ['./practitioner-testimonial.component.scss']
})
export class PractitionerTestimonialComponent implements OnInit, OnDestroy {
  practitioner: Promise<Practitioner>;
  _practitioner: Practitioner;
  values = TestimonialValues.getValues();
  valuesCount: number = 0;

  testimonialForm: FormGroup;
  isLoading: boolean = false;
  error: string = null;
  disableSubmit: boolean = false;
  success: string = null;
  testimonialSubscription: Subscription;

  constructor(private practitionerService: PractitionerService, private testimonialService: TestimonialService, private route: ActivatedRoute, private mailService: MailService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      const id = params['id'];
      this.practitioner = this.practitionerService.getPractitioner(id).toPromise();
      this.practitioner.then(prac => {
        this._practitioner = prac;
      });
    });
    this._initializeForm();
  }

  ngOnDestroy(): void {
    if (!this.testimonialSubscription) { return; }
    this.testimonialSubscription.unsubscribe();
  }

  _initializeForm(): void {
    this.testimonialForm = new FormGroup({
      'description': new FormControl(null, Validators.required),
      'email': new FormControl(null, [Validators.required, Validators.email]),
      'firstName': new FormControl(null, Validators.required),
      'lastName': new FormControl(null),
      'photos': new FormArray([]),
      'rating': new FormControl(5, Validators.required),
      'values': new FormArray([])
    });
  }

  updateRating(value: number): void {
    this.testimonialForm.get('rating').setValue(value);
  }

  onValueSelected(index: number): void {
    var newValue = !this.values[index].selected;
    this.values[index].selected = newValue;
    this.valuesCount = newValue ? this.valuesCount + 1 : this.valuesCount - 1;

    if (newValue) {
      this.testimonialForm.get('values').markAsTouched();
    }
  }

  onSubmit(): void {
    console.log(this.testimonialForm);
    if (this.testimonialForm.invalid || this.valuesCount === 0) { return; }

    this.isLoading = true;
    this.error = null;
    this.disableSubmit = true;

    var selectedValues: string[] = [];
    this.values.forEach(value => {
      if (value.selected) {
        selectedValues.push(value.property);
      }
    });

    var testimonial: Testimonial = new Testimonial(
      this.testimonialForm.value.description,
      this.testimonialForm.value.email,
      this.testimonialForm.value.firstName,
      this.testimonialForm.value.lastName,
      [],
      this.testimonialForm.value.rating,
      selectedValues,
      new Date().getTime(),
      new Date().getTime()
    );

    if (this._practitioner) {
      const testimonialIndex = this._practitioner.testimonials.findIndex(currentTestimonial => testimonial.email.toLowerCase() === currentTestimonial.email.toLowerCase());
      if (testimonialIndex > -1) {
        this.error = 'A testimonial has already been submitted with this email.';
        this.isLoading = false;
        this.disableSubmit = false;
        return;
      }

      this.testimonialService.createTestimonial(this._practitioner.id, testimonial, this._practitioner.rating).then(_ => {
        this.isLoading = false;
        this.success = 'Thank you for submitting your testimonial!';
        this.mailService.sendPractitionerTestimonialReceivedEmail(this._practitioner);
      }, error => {
        this.error = error;
        this.disableSubmit = false;
        this.isLoading = false;
      });
    }
  }

}
